export enum ADDRESS_TYPE {
    SHIPPING,
    BILLING
}